import React from 'react';
import { Link } from 'react-router-dom';
import { FaTachometerAlt, FaBusinessTime, FaBook, FaMoneyBillWave } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

function MobileNav({ activeLink, handleLinkClick, signOutUser }) {
  return (
    <div className="d-md-none border-top d-flex gap-3 p-3 px-4 position-fixed bottom-0 align-items-center bg-light justify-content-between text-dark w-100">
      <Link
        className={`btn ${activeLink === 'dashboard' ? 'btn-secondary text-warning' : 'btn-light'} p-2`}
        to="/dashboard/screens"
        onClick={() => handleLinkClick('dashboard')}
      >
        <FaTachometerAlt size={24} />
      </Link>
      <Link
        className={`btn ${activeLink === 'businessInfo' ? 'btn-secondary text-warning' : 'btn-light'} p-2`}
        to="/dashboard/screens/businessInfo"
        onClick={() => handleLinkClick('businessInfo')}
      >
        <FaBusinessTime size={24} />
      </Link>
      <Link
        className={`btn ${activeLink === 'bookings' ? 'btn-secondary text-warning' : 'btn-light'} p-2`}
        to="/dashboard/screens/bookings"
        onClick={() => handleLinkClick('bookings')}
      >
        <FaBook size={24} />
      </Link>
      <Link
        className={`btn ${activeLink === 'withdraw' ? 'btn-secondary text-warning' : 'btn-light'} p-2`}
        to="/dashboard/screens/withdraw"
        onClick={() => handleLinkClick('withdraw')}
      >
        <FaMoneyBillWave size={24} />
      </Link>
      <Button variant="danger" onClick={signOutUser}>
        Sign Out
      </Button>
    </div>
  );
}

export default MobileNav;
